import React from "react";
import "./App.css";
import MainPage from "./components/MainPage/MainPage";

function App() {
  return (
    <div className="container-fluid">
      <MainPage className="main-page" />
    </div>
  );
}

export default App;
